<template>
  <div>
    <div class="main-wrapper">
      <sidebar-component />
      <div class="page-wrapper">
        <navbar-component />
        <div class="page-content">
          <div class="d-flex justify-content-between align-items-center flex-wrap grid-margin">
            <div>
              <h4 class="mb-3 mb-md-0">Information Events</h4>
            </div>
            <div class="d-flex align-items-center flex-wrap text-nowrap">
              <router-link :to="{ name: 'InformationEventsAdd' }" class="btn btn-primary mb-2 mb-md-0">
                Add Information Event
              </router-link>
            </div>
          </div>

          <div class="row">
            <div class="col-12 col-xl-12 stretch-card">
              <div class="card">
                <div class="card-body">
                  <div class="d-flex justify-content-between align-items-baseline mb-2">
                    <h6 class="card-title mb-2">Information Events List</h6>
                  </div>

                  <vue-good-table
                    :columns="columns"
                    :rows="informationEvents"
                    :pagination-options="paginationOptions"
                    :search-options="searchOptions"
                    :sort-options="sortOptions"
                    styleClass="vgt-table striped"
                    :isLoading="isLoading"
                    :totalRows="totalRows"
                    :server-params="serverParams"
                    @on-page-change="onPageChange"
                    @on-sort-change="onSortChange"
                    @on-column-filter="onColumnFilter"
                    @on-per-page-change="onPerPageChange"
                    mode="remote"
                  >
                    <template slot="table-row" slot-scope="props">
                      <span v-if="props.column.field == 'image'">
                        <img 
                          v-if="props.row.image" 
                          :src="props.row.image" 
                          alt="Event Image" 
                          style="width: 60px; height: 40px; object-fit: cover; border-radius: 4px;"
                        />
                        <span v-else class="text-muted">No Image</span>
                      </span>
                      <span v-else-if="props.column.field == 'status'">
                        <span 
                          class="badge" 
                          :class="{
                            'badge-success': props.row.status === 'ongoing',
                            'badge-info': props.row.status === 'upcoming',
                            'badge-secondary': props.row.status === 'past'
                          }"
                        >
                          {{ getStatusText(props.row.status) }}
                        </span>
                      </span>
                      <span v-else-if="props.column.field == 'is_active'">
                        <span 
                          class="badge" 
                          :class="props.row.is_active ? 'badge-success' : 'badge-danger'"
                        >
                          {{ props.row.is_active ? 'Active' : 'Inactive' }}
                        </span>
                      </span>
                      <span v-else-if="props.column.field == 'date_range'">
                        {{ props.row.date_range }}
                      </span>
                      <span v-else-if="props.column.field == 'actions'">
                            <a
                              href="#"
                              title="Detail"
                              @click.prevent="
                                viewDetail(props.row)
                              "
                            >
                              <i class="mdi mdi-eye" style="font-size:16px"></i>
                              
                            </a>
                            <a
                              href="#"
                              title="Edit"
                              @click.prevent="editEvent(props.row)"
                            >
                              <i class="mdi mdi-square-edit-outline" style="font-size:16px"></i>
                              
                            </a>

                            <a
                              href="#"
                              title="Delete"
                              @click.prevent="
                                deleteEvent(props.row.id)
                              "
                            >
                              <i class="mdi mdi-trash-can-outline" style="font-size:16px"></i> 
                            </a>
                      </span>
                      <span v-else>
                        {{ props.formattedRow[props.column.field] }}
                      </span>
                    </template>
                  </vue-good-table>
                </div>
              </div>
            </div>
          </div>
        </div>
        <footer-component />
      </div>
    </div>
  </div>
</template>

<script>
import sidebarComponent from "@/components/_partials/_sidebar";
import navbarComponent from "@/components/_partials/_navbar";
import footerComponent from "@/components/_partials/_footer";

export default {
  name: "InformationEventsIndex",
  components: {
    "sidebar-component": sidebarComponent,
    "navbar-component": navbarComponent,
    "footer-component": footerComponent,
  },
  data() {
    return {
      informationEvents: [],
      isLoading: false,
      totalRows: 0,
      serverParams: {
        columnFilters: {},
        sort: {
          field: 'created_at',
          type: 'desc'
        },
        page: 1,
        perPage: 10
      },
      columns: [
        {
          label: 'Image',
          field: 'image',
          sortable: false,
          width: '100px'
        },
        {
          label: 'Name',
          field: 'name',
          sortable: true,
          filterOptions: {
            enabled: true,
            placeholder: 'Search name...'
          }
        },
        {
          label: 'Date Range',
          field: 'date_range',
          sortable: false
        },
        {
          label: 'Status',
          field: 'status',
          sortable: false,
          filterOptions: {
            enabled: true,
            filterDropdownItems: [
              { value: 'upcoming', text: 'Upcoming' },
              { value: 'ongoing', text: 'Ongoing' },
              { value: 'past', text: 'Past' }
            ]
          }
        },
        {
          label: 'Active',
          field: 'is_active',
          sortable: true,
          filterOptions: {
            enabled: true,
            filterDropdownItems: [
              { value: true, text: 'Active' },
              { value: false, text: 'Inactive' }
            ]
          }
        },
        {
          label: 'Created At',
          field: 'created_at',
          sortable: true,
          type: 'date',
          dateInputFormat: 'yyyy-MM-dd\'T\'HH:mm:ss.SSSSSS\'Z\'',
          dateOutputFormat: 'dd MMM yyyy HH:mm'
        },
        {
          label: 'Actions',
          field: 'actions',
          sortable: false,
          width: '150px'
        }
      ],
      paginationOptions: {
        enabled: true,
        mode: 'remote',
        perPage: 10,
        perPageDropdown: [10, 25, 50, 100],
        dropdownAllowAll: false,
        setCurrentPage: 1,
        nextLabel: 'Next',
        prevLabel: 'Prev',
        rowsPerPageLabel: 'Rows per page',
        ofLabel: 'of',
        pageLabel: 'page',
        allLabel: 'All'
      },
      searchOptions: {
        enabled: true,
        trigger: 'enter',
        placeholder: 'Search events...'
      },
      sortOptions: {
        enabled: true,
        initialSortBy: { field: 'created_at', type: 'desc' }
      }
    };
  },
  methods: {
    loadInformationEvents() {
      this.isLoading = true;
      
      const params = new URLSearchParams({
        limit: this.serverParams.perPage,
        page: this.serverParams.page,
        sort_field: this.serverParams.sort.field || 'created_at',
        sort_type: this.serverParams.sort.type || 'desc'
      });

      // Add column filters
      Object.keys(this.serverParams.columnFilters).forEach(key => {
        if (this.serverParams.columnFilters[key]) {
          params.append(key, this.serverParams.columnFilters[key]);
        }
      });

      const baseURI = this.$settings.endPoint + "information-events/?" + params.toString();
      
      return this.$http
        .get(baseURI, {
          timeout: 10000,
          headers: {
            'AppToken': this.$settings.jwtSecret,
          }
        })
        .then((response) => {
          this.isLoading = false;
          if (response.data.status === 200) {
            this.informationEvents = response.data.datas.data;
            this.totalRows = response.data.datas.total;
          }
        })
        .catch(error => {
          this.isLoading = false;
          this.handleError(error);
        });
    },

    viewDetail(event) {
      this.$router.push({ 
        name: 'InformationEventsDetail', 
        params: { id: this.$onRandom(event.id) } 
      });
    },

    editEvent(event) {
      this.$router.push({ 
        name: 'InformationEventsEdit', 
        params: { id: this.$onRandom(event.id) } 
      });
    },

    deleteEvent(eventId) {
      this.$swal({
        title: 'Are you sure?',
        text: "You won't be able to revert this!",
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Yes, delete it!'
      }).then((result) => {
        if (result.isConfirmed) {
          const baseURI = this.$settings.endPoint + "information-events/delete/" + eventId;
          
          this.$http
            .delete(baseURI, {
              headers: {
                'AppToken': this.$settings.jwtSecret,
              }
            })
            .then((response) => {
              if (response.data.status === 200) {
                this.$swal('Deleted!', 'Information event has been deleted.', 'success');
                this.loadInformationEvents();
              }
            })
            .catch(error => {
              this.handleError(error);
            });
        }
      });
    },

    getStatusText(status) {
      switch (status) {
        case 'upcoming':
          return 'Upcoming';
        case 'ongoing':
          return 'Ongoing';
        case 'past':
          return 'Past';
        default:
          return status;
      }
    },

    // Table event handlers
    onPageChange(params) {
      this.serverParams.page = params.currentPage;
      this.loadInformationEvents();
    },

    onPerPageChange(params) {
      this.serverParams.perPage = params.currentPerPage;
      this.serverParams.page = 1;
      this.loadInformationEvents();
    },

    onSortChange(params) {
      this.serverParams.sort = {
        field: params[0].field,
        type: params[0].type
      };
      this.loadInformationEvents();
    },

    onColumnFilter(params) {
      this.serverParams.columnFilters = {};
      for (let filter of params.columnFilters) {
        this.serverParams.columnFilters[filter.field] = filter.value;
      }
      this.serverParams.page = 1;
      this.loadInformationEvents();
    },

    handleError(error) {
      if (error.response) {
        if (error.response.status === 422) {
          console.error('Validation error:', error.response.data.errors);
        } else if (error.response.status === 500) {
          this.$router.push('/server-error');
        } else if (error.response.status === 401) {
          this.$router.push("/authorized-error");
        } else {
          this.$router.push('/page-not-found');
        }
      }
    }
  },

  mounted() {
    this.loadInformationEvents();
  }
};
</script>

<style scoped>
/* Styles will be inherited from the main theme */
</style>